<template>
	<div>
		<features-admin />

		<features-approbation />

		<features-documents />

		<div class="container">
			<div class="item">
				<h3 class="text-center mb-2">Et plus encore ...</h3>
			</div>
			<div class="text-center">
				<router-link :to="{name:'features'}" class="btn btn-light btn-lg">Découvrir toutes les fonctionnalités</router-link>
			</div>
		</div>

		<devis :meta="false" />

		<forme fill="#f8f9fa" />
		<appli :meta="false" bg="bg1" />

		<forme fill="#f8f9fa" :reverse="true" />
		<apropos :meta="false" />
	</div>
</template>
<script>
	import Apropos from "./apropos";
	import Devis from "./devis";
	import Appli from "./appli";
	import SectionFeatures from "./x/section-features";
	import FeaturesAdmin from "./features-admin";
	import FeaturesApprobation from "./features-approbation";
	import FeaturesDocuments from "./features-documents";

	export default{
		components:{
			FeaturesDocuments,
			FeaturesApprobation,
			FeaturesAdmin,
			SectionFeatures,
			Appli,
			Devis,
			Apropos,
		},
	}
</script>
<style lang="less" scoped>
	.item{
		.xxx{
			p{
				margin: 0;
			}
			h3{
				margin-top: 2vh;
				color: black!important;
			}
		}
	}
</style>
